import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoRegiaoMultiselectComponent } from './novo-regiao-multiselect.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoRegiaoMultiselectComponent],
  exports: [NovoRegiaoMultiselectComponent]
})
export class NovoRegiaoMultiselectModule {}
